module.exports = __webpack_public_path__ + "static/img/c1.f784f28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/pit/mine/c1.jpg
// module id = Iuqt
// module chunks = 0